import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("ic_admin_token");
export const setToken = (t) =>
    t ? localStorage.setItem("ic_admin_token", t) : localStorage.removeItem("ic_admin_token");

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
    const t = getToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

export const login = (email, password) =>
    axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const fetchMe = () => adminApi.get("/auth/me").then((r) => r.data);
export const adminFetchArticles = () => adminApi.get("/admin/articles").then((r) => r.data);
export const adminFetchArticle = (id) => adminApi.get(`/admin/articles/${id}`).then((r) => r.data);
export const adminCreateArticle = (data) => adminApi.post("/admin/articles", data).then((r) => r.data);
export const adminUpdateArticle = (id, data) => adminApi.put(`/admin/articles/${id}`, data).then((r) => r.data);
export const adminDeleteArticle = (id) => adminApi.delete(`/admin/articles/${id}`).then((r) => r.data);
export const adminFetchMessages = () => adminApi.get("/admin/messages").then((r) => r.data);
export const adminFetchSubscribers = () => adminApi.get("/admin/subscribers").then((r) => r.data);
export const adminSendNewsletter = (data) => adminApi.post("/admin/newsletter/send", data).then((r) => r.data);
export const adminFetchNewsletterDraft = () => adminApi.get("/admin/newsletter/draft-latest").then((r) => r.data);
export const adminFetchCampaigns = () => adminApi.get("/admin/campaigns").then((r) => r.data);
export const adminFetchAutoSend = () => adminApi.get("/admin/newsletter/auto").then((r) => r.data);
export const adminSaveAutoSend = (data) => adminApi.put("/admin/newsletter/auto", data).then((r) => r.data);
export const adminFetchMonetization = () => adminApi.get("/monetization").then((r) => r.data);
export const adminSaveMonetization = (data) => adminApi.put("/admin/monetization", data).then((r) => r.data);
export const adminCreateCategory = (name) => adminApi.post("/admin/categories", { name }).then((r) => r.data);
export const adminRenameCategory = (id, name) => adminApi.put(`/admin/categories/${id}`, { name }).then((r) => r.data);
export const adminDeleteCategory = (id) => adminApi.delete(`/admin/categories/${id}`).then((r) => r.data);
export const adminFetchComments = () => adminApi.get("/admin/comments").then((r) => r.data);
export const adminApproveComment = (id) => adminApi.put(`/admin/comments/${id}/approve`).then((r) => r.data);
export const adminDeleteComment = (id) => adminApi.delete(`/admin/comments/${id}`).then((r) => r.data);

export const adminUploadImage = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return adminApi.post("/admin/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
};

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const fileUrl = (path) => (path ? `${BACKEND}/api/files/${path}` : null);
export const submitContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);

export function formatApiError(detail) {
    if (detail == null) return "Algo deu errado. Tente novamente.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
